/* eslint-disable prefer-promise-reject-errors */
import axios from 'axios';
import { sites } from '../helpers/globalVariables';
import config from '../helpers/config';
import linkToMyAccount from '../api/designBuilder/linkToMyAccount';
import * as thdUser from '../../common/thdUserInfo';


class LinkStrategy {
  constructor(designId) {
    this.designIdToSave = designId;
    this.axiosPromise = null;
  }

  performLink = () => {
  }
}

class THDLinkEstimate extends LinkStrategy {
  constructor(designId) {
    super(designId);
    this.userInfo = thdUser.getLoggedInUserInfo();
  }

  performLink = () => {
    this.axiosPromise = thdUser.isLoggedIn()
      ? linkToMyAccount(this.designIdToSave, this.userInfo.identityId, this.userInfo.email)
      : Promise.reject('Cannot Link Estimate. User is not logged in');
    return this.axiosPromise;
  }
}

class BlindsComLinkEstimate extends LinkStrategy {
  performLink = () => {
    const payload = { designId: this.designIdToSave };
    this.axiosPromise =
      axios.post(config.eleanorDesignBuilderProxyLinkToMyAccount, payload);
    return this.axiosPromise;
  }
}


class NotImplimentedLinkEstimate extends LinkStrategy {
  constructor(designId) {
    super(designId);
    this.axiosPromise = Promise.reject('A save strategy was not implemented for this site.');
  }

  performLink() {
    /* eslint no-console: "off" */
    console.warn('Design was not saved. A save strategy was not implemented for this site.');
    return this.axiosPromise;
  }
}


export default class LinkEstimateContext {
  constructor(designId) {
    switch (window.globalConfig.siteId) {
      case sites.theHomeDepot:
        this.strategy = new THDLinkEstimate(designId);
        break;
      case sites.blinds:
        this.strategy = new BlindsComLinkEstimate(designId);
        break;
      default:
        this.strategy = new NotImplimentedLinkEstimate(designId);
    }
  }

  saveToMyAccount = () => this.strategy.performLink()
}
